/* src/app/shared/components/paginator/paginator.component.scss */
.paginator-main-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}
.paginator-label {
  color: #001A33;
  font: 400 14px FranceTV Brown;
  margin-right: 15px;
}
.paginator-text {
  color: #001A33;
  font: 400 14px FranceTV Brown;
  margin-right: 15px;
  margin-left: 15px;
}
.button-container {
  display: flex;
  margin-right: 15px;
}
.right-margin {
  margin-right: 10px;
}
/*# sourceMappingURL=paginator.component.css.map */
